export default {
  install: function (Vue, options) {
    Vue.mixin({
      computed: {
        isDevelopment () {
          return process.env.NODE_ENV === 'development'
        },
        isMobile () {
          return options ? options.isMobile : undefined;
        },
        mitarbeiterverwaltungLink () {
          return process.env.VUE_APP_MITARBEITERVERWALTUNG_URL
        },
        ausundweiterbildungLink () {
          return process.env.VUE_APP_AUSUNDWEITERBILDUNG_URL
        }
      }
    })
  }
}
